import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { PopupService } from 'src/app/services/popup.service';
import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';
import * as moment from 'moment';
import { UtilsService } from 'src/app/services/utils.service';
import { CollectionPopupComponent } from '../../shared';

@Component({
  selector: 'app-filter-popup',
  templateUrl: './filter-popup.component.html',
  styleUrls: ['./filter-popup.component.scss']
})
export class FilterPopupComponent implements OnInit {
  formGroup: FormGroup | any;
  aisFormGroup: FormGroup | any;
  error: boolean;
  isLeftHighlighted: boolean = false;
  isRightHighlighted: boolean = true;
  maxValue = 10080;
  minValue = 10;
  clydeAisFormGroup: FormGroup | any;
  duration: any;
  isPlaying: boolean = false;
  downloadImage: string;
  darkTheme: any;
  previousIndex: number | null = null;
  currentAudio: HTMLAudioElement | null = null;
  audioFiles: any;
  minDate: Date;
  maxDate: Date;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  vesselCountries: any[];
  vesselDestinations: any[];
  vesselFormGroup: FormGroup | any;
  DateformGroup: FormGroup | any;
  vesselTypes: any[];
  isLeftSpeed: boolean = false;
  isRightSpeed: boolean = true;
  minStartDate!: Date;
  maxEndDate!: Date;
  currentLocalTime: string;
  DateFilter: any;
  isTimePickerOpen: boolean;
  @ViewChild('timepicker') timepicker: NgxMaterialTimepickerComponent;
  @ViewChild('pickers') pickers: NgxMaterialTimepickerComponent;
  IMONumbers: any[];
  MMSIList: any[];
  vesselNames: any[];
  observationformGroup: FormGroup | any;
  observationData: any;
  errormessage: string;
  inputStatus :string
  duplicateDetected: boolean;
  tooltipImagePath: string;
  historicalData:boolean = false;
  predicitionData:boolean = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorageService: DataService,
    private apiService: ApiService,
    private popupService: PopupService,
    private utilsService: UtilsService,
    private dataService: DataService
  ) {
    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
    this.downloadImage = this.darkTheme ? '../../../assets/images/icon-dark.svg' : '../../../assets/images/icon-img.svg';
    });
    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    });
    if(data.type === 'audio') {
      this.audioFiles = this.data.signals
      .flatMap(item => item.audioFiles || []);
    }

    if (data.type === 'aisVessel') {
      this.vesselFormGroup = new FormGroup({
        vesselLength: new FormControl(''),
        flag: new FormControl(''),
        destination: new FormControl(''),
        vesselType: new FormControl(''),
        vesselSpeed: new FormControl(''),
        IMO: new FormControl(''),
        MMSI: new FormControl(''),
        vesselName: new FormControl(''),
      });

      if (this.data.refreshData) {
        this.vesselCountries = this.data.flagArray.sort();
        this.vesselDestinations = this.data.detinationArray.sort();
        this.vesselTypes = this.data.vesselTypeArray.sort();
        this.IMONumbers = this.data.IMONumbers.sort();
        this.MMSIList = this.data.MMSIList.sort();
        this.vesselNames = this.data.vesselNames.sort();
      } else {
        // Extract unique flags
        const uniqueFlags = [...new Set(
          this.data.vesselData.features
            .map(feature => feature.properties.Flag)
            .filter(flag =>
              flag !== null &&
              flag !== undefined &&
              flag !== 'N/A' &&
              flag.trim() !== ''
            )
        )].sort();

        const uniqueDestinations = [...new Set(
          this.data.vesselData.features
            .map(feature => feature.properties.Destination)
            .filter(destination =>
              destination !== null &&
              destination !== undefined &&
              destination !== 'N/A' &&
              destination.trim() !== ''
            )
        )].sort();

        const uniqueVesselTypes = [...new Set(
          this.data.vesselData.features
            .map(feature => feature.properties['Ship Type'])
            .filter(type =>
              type !== null &&
              type !== undefined &&
              type !== 'N/A' &&
              type.trim() !== ''
            )
        )].sort();

        const uniqueIMONumbers = [...new Set(
          this.data.vesselData.features
            .map(feature => feature.properties.IMO)
            .filter(type =>
              type !== null &&
              type !== undefined && 
              type !== 'N/A'
            )
        )].sort();

        const uniqueMMSIList = [...new Set(
          this.data.vesselData.features
            .map(feature => feature.properties.MMSI)
            .filter(type =>
              type !== null &&
              type !== undefined &&
              type !== 'N/A'
            )
        )].sort();

        const uniquevesselNames = [...new Set(
          this.data.vesselData.features
            .map(feature => feature.properties.Name)
            .filter(type =>
              type !== null &&
              type !== undefined &&
              type !== 'N/A'
            )
        )].sort();

        this.vesselCountries = uniqueFlags;
        this.vesselDestinations = uniqueDestinations;
        this.vesselTypes = uniqueVesselTypes;
        this.IMONumbers = uniqueIMONumbers;
        this.MMSIList = uniqueMMSIList;
        this.vesselNames = uniquevesselNames;
      }

      if (this.data.filterObject != undefined || this.data.filterObject != null) {
        this.vesselFormGroup.get('vesselLength').setValue(this.data.filterObject?.length);
        this.vesselFormGroup.get('flag').setValue(this.data.filterObject?.flag);
        this.vesselFormGroup.get('destination').setValue(this.data.filterObject?.destination);
        this.vesselFormGroup.get('vesselType').setValue(this.data.filterObject?.vesselType);
        this.vesselFormGroup.get('vesselSpeed').setValue(this.data.filterObject?.vesselSpeed);
        this.vesselFormGroup.get('vesselName').setValue(this.data.filterObject?.vesselName);
        this.vesselFormGroup.get('MMSI').setValue(this.data.filterObject?.MMSI);
        this.vesselFormGroup.get('IMO').setValue(this.data.filterObject?.IMO);

        this.isLeftHighlighted = !this.data.filterObject?.isGreater;
        this.isRightHighlighted = this.data.filterObject?.isGreater || false;

        this.isLeftSpeed = !this.data.filterObject?.isSpeedGreaterThan;
        this.isRightSpeed = this.data.filterObject?.isSpeedGreaterThan || false;
        

      }
    }

  }

  ngOnInit(): void {

    this.formGroup = new FormGroup({
      vesselLength: new FormControl('')
    });

    this.aisFormGroup = new FormGroup({
      historicalTime: new FormControl('')
    });

    this.clydeAisFormGroup = new FormGroup({
      historicalTime: new FormControl('')
    });

    this.observationformGroup = new FormGroup({
      observationvalue: new FormControl(this.data.value)
    });
    if (this.data?.operator?.trim().toLowerCase() === 'lesser') {
      this.isLeftHighlighted = true;
      this.isRightHighlighted = false;
    }

    this.formGroup.valueChanges.subscribe(() => {
      this.error = false;
      const length = this.formGroup.get('vesselLength').value;

      if (length < 0) {
        this.error = true;
      }
    });

    this.aisFormGroup.valueChanges.subscribe(() => {
      this.error = false;
      const duration = this.aisFormGroup.get('historicalTime').value;
      if (duration < this.minValue || duration > this.maxValue || !this.isPositiveWholeNumber(duration)) {
        this.error = true;
      }
    });

    this.clydeAisFormGroup.valueChanges.subscribe(() => {
      this.error = false;
      this.duration = '';
      this.duration = this.clydeAisFormGroup.get('historicalTime').value;
      if (this.selectedOption === 'minutes') {
        const minutesPerDay = 1440;
        this.duration = Math.ceil(this.duration/minutesPerDay);
      }
      
      if (this.duration < 0 || this.duration > this.data?.historicalDays || !this.isPositiveWholeNumber(this.duration)) {
        this.error = true;
      }
    });

    this.observationformGroup.valueChanges.subscribe(() => {
      this.error = false;
      const observationData = this.observationformGroup.get('observationvalue').value;
    });
    if (this.data.type === 'date') {
        const openWindow = new Date(this.data.startDate);
        const closeWindow = new Date(this.data.endDate);

        this.minDate = openWindow;
        this.maxDate = closeWindow;
    }

    if (this.data.type === 'refreshDateFilter') {
      this.setDateRange();
      this.DateformGroup = new FormGroup({
        startDate: new FormControl('',[Validators.required]),
        endDate: new FormControl('',[Validators.required]),
        startTime: new FormControl('',[Validators.required]),
        endTime: new FormControl('',[Validators.required]),
      });

      this.DateformGroup.valueChanges.subscribe(() => {
        this.isEndDateInvalid();
      });

      this.isTimePickerOpen = false;
    }
  }

  onClick(e: any, option: any) {
    let result: any = undefined;
    if (option == 2) {
      result = {
        length: this.formGroup.value.vesselLength,
        isGreater: this.isRightHighlighted
      }
    }
    this.dialogRef.close(result);
  }

  selectGreaterThan() {
    this.isLeftHighlighted = false;
    this.isRightHighlighted = true;
  }

  selectLessThan() {
    this.isLeftHighlighted = true;
    this.isRightHighlighted = false;
  }

  onSubmit(e: any, option: any) {
    let result: any = undefined;
    if (option == 2) {
      if(this.data.type == 'ais') {
        result = {
          duration: this.aisFormGroup.value.historicalTime,
          type: 'history'
        }
      } else {
        result = {
          duration: this.clydeAisFormGroup.value.historicalTime,
          type: this.selectedOption
        }
      }
    }
    if (option == 3) {
      result = {
        type: 'prediction',
        predictionCount: 5
      }
    }
    this.dialogRef.close(result);
  }

  selectedOption: string | null = 'minutes';

  onCheckboxChange(event: any, option: string) {
    if (event.checked) {
      this.selectedOption = option;
    } else {
      this.selectedOption = null;
    }
    this.clydeAisFormGroup.get('historicalTime').setValue(null);
  }

  isPositiveWholeNumber(value: number): boolean {    
    return value !== null && value >= 1 && value % 1 === 0;
  }

  togglePlayPause(item: any, index: number) {
    // Check if the current audio is already playing
    if (item.isPlaying) {
      this.pauseAudio();
      item.isPlaying = false; // Set the current item's isPlaying to false
    } else {
      // If a previous audio was playing, pause it and set its isPlaying to false
      if (this.previousIndex !== null && this.previousIndex !== index) {
        this.audioFiles[this.previousIndex].isPlaying = false;
        this.pauseAudio();
      }
  
      // Get the audio URL from API and play the current audio
      this.getAudioUrlFromApi(item).then((audioUrl) => {
        this.playAudio(audioUrl, item, index);
      });
    }
  }
  
  playAudio(url: string, item: any, index: number) {
    this.currentAudio = new Audio(url); // Create a new audio element
    this.currentAudio.play();
  
    // Set the current audio's isPlaying state to true
    item.isPlaying = true;
    this.previousIndex = index;
  
    // When the audio ends, reset the isPlaying state
    this.currentAudio.onended = () => {
      item.isPlaying = false;
    };
  }

  pauseAudio() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0; // Reset audio to the beginning
    }
  }

  getAudio(item: any, action: string) {
    if (action === 'download') {
      // Fetch the audio file URL and trigger download
      this.getAudioUrlFromApi(item).then((audioUrl) => {
        this.downloadAudio(audioUrl,item);
      });
    }
  }

  getAudioUrlFromApi(item: any): Promise<string> {
    let taskId = this.data.sensorData.taskId;
    let sensorObj = this.data.sensorData;
    sensorObj.fileName = item.fileName;
  
    return new Promise((resolve, reject) => {
      this.apiService.getCollectionImage(taskId, sensorObj).subscribe(
        (res: any) => {
          if (res?.msg === 'Failed') {
            const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            reject(message);
          } else if (res?.msg === 'user storage') {
            const message = 'We cannot access the audio as the delivery was made to your storage. You can access the audio via your storage.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            reject(message);
          } else if (res?.result?.audioUrl) {
            resolve(res.result.audioUrl);
          }
        },
        (error) => reject('API error occurred')
      );
    });
  }

  getFileNameFromS3SignedUrl(signedUrl) {
    const filename = signedUrl.split('/')[signedUrl.split('/').length - 1].split('?')[0];    
    return `${filename}`;
  }
  

  downloadAudio(url: string,item) {  
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    item.isDownloading = true;

    xhr.onload = () => {
      if (xhr.status === 200) {        
        const blob = xhr.response;
        const fileName = this.getFileNameFromS3SignedUrl(url);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
      item.isDownloading = false;
    };

    xhr.onerror = () => {
      item.isDownloading = false;
    };
    xhr.send();
  }
  
  submitDate() {
    this.dialogRef.close(this.range.value);
  }

  onSave() {
    let result: any = undefined;
    result = {
      length: this.vesselFormGroup.value.vesselLength,
      isGreater: this.isRightHighlighted,
      destination: this.vesselFormGroup.value.destination,
      flag: this.vesselFormGroup.value.flag,
      vesselType: this.vesselFormGroup.value.vesselType,
      vesselSpeed: this.vesselFormGroup.value.vesselSpeed,
      isSpeedGreaterThan: this.isRightSpeed,
      vesselName: this.vesselFormGroup.value.vesselName,
      MMSI: this.vesselFormGroup.value.MMSI,
      IMO: this.vesselFormGroup.value.IMO
    }
    
    this.dialogRef.close(result);
  }

  isFormEmpty(): boolean {
    const length = this.vesselFormGroup.get('vesselLength').value;
    const speed = this.vesselFormGroup.get('vesselSpeed').value;
    let error;
    if ((length && length < 0) || (speed && speed < 0)) {
      error = true;
    }

    return (Object.values(this.vesselFormGroup.value).every(value => value === null || value === '')) || error;
  }

  resetForm() {
    this.vesselFormGroup.reset();
  }

  selectSpeedGreaterThan() {
    this.isLeftSpeed = false;
    this.isRightSpeed = true;
  }

  selectSpeedLessThan() {
    this.isLeftSpeed = true;
    this.isRightSpeed = false;
  }

  applyFilter() {
    let dateValues = this.combineDateTime();
    if (dateValues) {
      let response = {
        startDateTime: dateValues.startDateTime,
        endDateTime: dateValues.endDateTime
      }
      this.dialogRef.close(response);
    }
  }

  setDateRange() {
    const refreshHistory = this.data.refreshHistory;
   
    if (refreshHistory.length) {
      // Convert history names to Date objects
    const dates = refreshHistory.map(item => new Date(item.name));

    // Get min and max timestamps
    const minTime = Math.min(...dates.map(d => d.getTime()));
    const maxTime = Math.max(...dates.map(d => d.getTime()));

    // Assign correctly: minStartDate should be the earliest, maxEndDate the latest
    this.minStartDate = new Date(minTime);
    this.maxEndDate = new Date(maxTime);
    }
  }

  ngAfterViewInit() {
    if (this.timepicker) {

      // Subscribe to the closed event
      this.timepicker.timeSet.subscribe(() => {
        this.isTimePickerOpen = false;
      });

      // If available, also subscribe to a cancel or closed event
      if (this.timepicker.closed) {
        this.timepicker.closed.subscribe(() => {
          this.isTimePickerOpen = false;
        });
      }

      this.pickers.timeSet.subscribe(() => {
        this.isTimePickerOpen = false;
      });

      if (this.pickers.closed) {
        this.pickers.closed.subscribe(() => {
          this.isTimePickerOpen = false;
        });
      }
    }
  }
  
  openDate(timepicker: NgxMaterialTimepickerComponent) {
    if (this.isTimePickerOpen) {
      timepicker.close();
      this.isTimePickerOpen = false;
    } else {
      this.updateCurrentLocalTime();
      timepicker.defaultTime = this.currentLocalTime;
      timepicker.open();
      this.isTimePickerOpen = true;
    }
  }

  updateCurrentLocalTime() {
    this.currentLocalTime = this.utilsService.getCurrentLocalTime(this.data.currentUser);    
  }

  onTimeSet(event: any) {
    let selectedDate = this.DateformGroup.get('startDate')?.value;
    let utcDateTime = this.onTimeChange(event, selectedDate);

    setTimeout(() => {
      this.DateformGroup.patchValue({
        startTime: utcDateTime.utcTime
      });
    }, 0);

    let startDate = utcDateTime.utcDate
    this.DateformGroup.get('startDate').setValue(startDate);
  }

  onEndTimeSet(event: any) {
    let selectedDate = this.DateformGroup.get('endDate')?.value;
    let utcDateTime = this.onTimeChange(event, selectedDate);
    
    setTimeout(() => {
      this.DateformGroup.patchValue({
        endTime: utcDateTime.utcTime
      });
    }, 0);

    let endDate = utcDateTime.utcDate
    this.DateformGroup.get('endDate').setValue(endDate);
  }

  onTimeChange(event: any, date: any) {
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(localTime, 'YYYY-MM-DD HH:mm A', this.utilsService.getTimezoneFromCountry(this.data.currentUser.country)); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('hh:mm A');
    return { utcTime, utcDate };
  }

  combineDateTime() {
    const startDate = new Date(this.DateformGroup.value.startDate); // Already UTC
    const startTime = this.DateformGroup.value.startTime;
    const endDate = new Date(this.DateformGroup.value.endDate); // Already UTC
    const endTime = this.DateformGroup.value.endTime;
  
    // Extract hours and minutes from startTime
    const [startHours, startMinutes] = startTime.split(/[: ]/);
    const startHours24 = startTime.includes('PM') ? (+startHours % 12) + 12 : +startHours % 12;
  
    // Set UTC hours and minutes for startDate
    startDate.setUTCHours(startHours24, +startMinutes, 0, 0);
  
    // Extract hours and minutes from endTime
    const [endHours, endMinutes] = endTime.split(/[: ]/);
    const endHours24 = endTime.includes('PM') ? (+endHours % 12) + 12 : +endHours % 12;
  
    // Set UTC hours and minutes for endDate
    endDate.setUTCHours(endHours24, +endMinutes, 0, 0);
  
    return { 
      startDateTime: startDate.toISOString(), 
      endDateTime: endDate.toISOString() 
    };
  }

  handleDateChange(type) {
    if(type === 1) this.DateformGroup.get('startTime').setValue(null);
    if(type === 2) this.DateformGroup.get('endTime').setValue(null);
  }
  
  get dateFileds() {
    return this.DateformGroup.controls;
  }
  get observationFileds() {
    return this.observationformGroup.controls;
  }

  isEndDateInvalid() {
    if (this.DateformGroup.value.endDate && this.DateformGroup.value.startDate && 
      this.DateformGroup.value.startTime && this.DateformGroup.value.endTime) {
      let dateValues = this.combineDateTime();
      if (new Date(dateValues.endDateTime) <= new Date(dateValues.startDateTime)) {
        this.DateformGroup.controls['endDate'].setErrors({ endDateInvalid: true });
      } else {
        this.DateformGroup.controls['endDate'].setErrors(null);
      }
    }
  }
  getPlaceholderText(type: string){
    if (type === 'count'){
      return 'Enter vessel count';
    }
    else if (type === 'location'){
    return 'Enter a coordinate (Lng, Lat)';
    } 
    else if (type === 'name'){
       return 'Enter a name';
    }
    else if (type === 'number'){
       return 'Enter a number';
    }
   return 'Enter area in sqkm';
  }
  setObservationValue(): void {
    let observations: any = undefined;
    this.observationData = this.observationformGroup.value.observationvalue;
     let operator = '';
    if (this.isRightHighlighted) {
        operator = 'greater';
    } else if (this.isLeftHighlighted) {
        operator = 'lesser';
    }

    const isdecimal = !Number.isInteger(Number(this.observationData));
    if ((this.data.dataType === 'count'|| this.data.dataType === 'number')&& (this.observationData <= 0 || isdecimal)) {
          this.errormessage = 'Enter an integer greater than zero.';
         return;
    }
    else if (this.data.dataType === 'area'&& this.observationData <= 0) {
          this.errormessage = 'Enter a value greater than zero.';
         return;
    }
    else if (this.data.dataType === 'location'){
      if (this.observationData.endsWith(';')) {
        this.observationData = this.observationData.slice(0, -1).trim();
      }
        this.inputStatus = this.isValidInput(this.observationData)
        if (this.inputStatus !== 'invalid') {
          const result = this.parsePolygonAOI(this.observationData);
          if(!result){
            return
          }
        } else {
           this.errormessage = "Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'.";
          return;
        }
    }
    this.dialogRef.close(
      observations = {
        value: this.observationData,
        action: operator
      });
  }

  parsePolygonAOI(input:any,) {
    var positionString = input.trim();
    var positionArray = positionString.split(',');
    const isValid = isArrayValid(positionArray);
    
    function isArrayValid(arr: string[]): boolean {
      const regex = /^-?\d*\.?\d+\s*-?\d*\.?\d+$/;
      return arr.every((str) => regex.test(str.trim()));
    }
    if (positionArray?.length > 2) {
      let isValidCoordPairs = true;
      const coordPairs = positionString.split(';').map(pair => pair.trim());
      const positions: { lon: number; lat: number }[] = [];
      const invalidPairs: string[] = [];
      const validCoords: string[] = [];
      const accuracy = 15;

      let firstPairKey: string | null = null;
      this.duplicateDetected = false;

      for (const pair of coordPairs) {
        const [lonStr, latStr] = pair.split(',').map(s => s.trim());
        const lon = Number(lonStr);
        const lat = Number(latStr);

        if (this.validateCoordinates(lon, lat) && lonStr !== "" && latStr !== "") {
          const formatted = `${lon.toFixed(accuracy)} ${lat.toFixed(accuracy)}`;

          if (!firstPairKey) {
            firstPairKey = formatted;
          } else if (formatted === firstPairKey) {
            validCoords.push(formatted);
            this.duplicateDetected = true;
            break; // Stop processing further pairs
          }

          validCoords.push(formatted);
          positions.push({ lon, lat });
        } else {
          isValidCoordPairs = false;
          invalidPairs.push(pair);
        }
      }
      if (positions.length >= 3 && isValidCoordPairs) {
        const turfCoords = validCoords.map(c => {
          const [lon, lat] = c.split(' ').map(Number);
          return [lon, lat];
        });
        const first = turfCoords[0];
        const last = turfCoords[turfCoords.length - 1];
        
        const isClosed =
          first[0] === last[0] &&
          first[1] === last[1];
        
        if (!isClosed) {
             this.errormessage= 'First and last coordinates must be the same to form a closed polygon.';
          return(false);
        }
        if (this.duplicateDetected && validCoords.length != coordPairs.length ) {
            this.errormessage = 'All the subsequent coordinates are ignored when the polygon is complete.';
          return(false);
        }
      } else if (!isValidCoordPairs) {
          this.errormessage = `Please enter the longitude followed by the latitude.`;
        return(false);
      }else {
          this.errormessage = `Not enough coordinates to draw an AOI polygon. Three or more pairs are required for a polygon.`;
        return(false);
      }
    }
    else 
    if (positionArray?.length === 2 ) {

      var longitude = parseFloat(positionArray[0]);
      var latitude = parseFloat(positionArray[1]);

      const isValids = this.validateCoordinates(longitude, latitude);
      if (!isValids) {
          this.errormessage = `Please enter the longitude followed by the latitude.`;
        return(false);
      }
    } 
    return(true);
  }

  isValidInput(input: string): any {
    const trimmed = input.trim();

    // Disallow trailing semicolon

    const singleCoordRegex = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/;
    const multipleCoordsRegex = /^(-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)(\s*;\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)*$/;

    // Just a number like "150.96" or "150.96,"
    const numberOnlyRegex = /^-?\d+(\.\d+)?$/;
    const endsWithCommaOnly = /^-?\d+(\.\d+)?,$/;

    if (singleCoordRegex.test(trimmed) || multipleCoordsRegex.test(trimmed)) return 'coordinate';
    
    if (numberOnlyRegex.test(trimmed) || endsWithCommaOnly.test(trimmed)) return 'invalid';


    return 'invalid';
  }
  validateCoordinates(longitude, latitude) {
    // Check if values are numbers
    if (isNaN(longitude) || isNaN(latitude)) {
      return false;
    }
    
    // Check longitude range (-180 to 180)
    if (longitude < -180 || longitude > 180) {
      return false;
    }
    
    // Check latitude range (-90 to 90)
    if (latitude < -90 || latitude > 90) {
      return false;
    }
    return true;
  }
  onInput(event: any) {
    const input = event.target.value;
    // Only allow numbers, commas, semicolons, and dots
    const sanitized = input.replace(/[^0-9,;.\-]/g, '');
    // Update the input element
    event.target.value = sanitized;
    // Update the FormControl
    this.observationformGroup.get('observationvalue')?.setValue(sanitized, { emitEvent: false });
  }
getFormattedTooltipValue(): string {
  const value = this.observationFileds.observationvalue.value;
  
  if (!value) {
    return '';
  }
  
  // Remove any spaces around commas and semicolons, then add consistent spacing
  let formatted = value.replace(/\s*;\s*/g, '; ');  // Normalize semicolon spacing
  
  return formatted;
}
onChangeData(data) {
  if (data === 'historic') {
    this.historicalData = true;
    this.predicitionData = false;
  } else {
    this.historicalData = false;
    this.predicitionData = true;
  }
}
}
